
import {useEffect, useState} from "react";
import {Flex, Typography, Button, Form, Alert, Input, App} from "antd";
import SignInUp from "../components/SignInUp";
import Favicon from "../icons/Favicon";
import {LockOutlined, UserOutlined} from "@ant-design/icons";
import {GoogleLogin} from "@react-oauth/google";
import {Link} from "react-router-dom";
import SignUpPattern from "../components/SignUpPattern";
import Clone from "../utils/clone";
import loadScript from "../utils/script";

function RouteForgotPassword(props) {

    const [authStatusMsg, setAuthStatusMsg] = useState(null);
    const { message, modal, notification } = App.useApp();
    useEffect(() => {

        loadScript('https://www.google.com/recaptcha/api.js?render='+process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY)
    }, []);

    const onFormSubmit = (values) => {
        //console.log('VALS:', values);
        window.grecaptcha.ready(function() {
            console.log('SITE_KEY',process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY,)
            window.grecaptcha.execute(process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY, {action: 'submit'}).then(function(token) {
                //console.log('TOKEN',token)
                forgotPassword(values.email, token).then( () => {})
            });
        });
    };

    async function forgotPassword (email,captchaToken) {
        let url = process.env.REACT_APP_SERVER_API_HOST+"/auth/forgot-password"
        try {
            let headers = new Headers()
            headers.append('Content-Type', 'application/json')
            let requestOptions = {
                method: 'POST',
                headers: headers,
                body:JSON.stringify({email:email,captchaToken:captchaToken})
            };

            const response = await fetch(url,requestOptions);
            if (response.status === 200) {
                const json = await response.json();
                console.log('RESPONSE:',json)

                if (json.error === null) {
                    message.open({type: 'success', content: 'An email for password reset had been sent!'});
                } else {
                    message.open({type: 'error', content: json.error});
                }
            } else {
                message.open({type: 'error', content: 'Password reset failed!'});
            }

        } catch (error) {
            console.error(error.message);
        }
    }

    return (
        <div className="view auth">
            <div className="col form">
                <div className="cont">
                    <Favicon></Favicon>
                    <Typography.Title className="header" level={3}>
                        Reset your password for Mocky
                    </Typography.Title>

                    <Form
                        name="login"
                        initialValues={{
                            remember: true,
                        }}
                        style={{
                            minWidth: 360,
                            maxWidth: 360,
                        }}
                        onFinish={onFormSubmit}
                    >
                        {authStatusMsg ? <div>
                            <Alert
                                key={authStatusMsg.key}
                                message={authStatusMsg.message}
                                description={authStatusMsg.description}
                                type={authStatusMsg.type || 'error'}
                                closable
                            />
                            <br/>
                        </div> : false}
                        <Form.Item
                            name="email"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input your Email!',
                                },
                            ]}
                        >
                            <Input prefix={<UserOutlined/>} placeholder="Email"/>
                        </Form.Item>
                        <div id="google-captcha"></div>
                        <Form.Item>
                            <Button block type="primary" htmlType="submit">Reset password via email</Button>
                        </Form.Item>
                    </Form>
                    <Link to="/signin">Go back to sign in </Link>
                </div>
            </div>
            <div className="col pattern">
                <SignUpPattern></SignUpPattern>
            </div>
        </div>
    );
}

export default RouteForgotPassword
